export const THEME_ONTRACKS = 'on-tracks';
export const THEME_CIRCLE = 'circle';
export const THEME_NYAN_CAT = 'nyan-cat';
export const THEME_TEXT = 'text';
export const THEME_DEFAULT = THEME_CIRCLE;
export const THEMES = [
  THEME_TEXT,
  THEME_CIRCLE,
  THEME_ONTRACKS,
  THEME_NYAN_CAT
];
export const SIZE_DEFAULT = 'L';
export const SIZES = ['L', 'M', 'S'];
export const RAINBOW_COLORS = [
  'red',
  'orange',
  'yellow',
  'green',
  'blue',
  'purple',
  'marine'
];
